import type { NavigationItem } from "adapters/navigation";
import { NAV__ITEM_SELECTED } from "constants/mixpanelEvents";
import { Mixpanel } from "providers/mixpanel";

type NavSource = "nav_press" | "mobile_menu";

const trackNavigationItem = (item: NavigationItem, source: NavSource) => {
  Mixpanel.track(NAV__ITEM_SELECTED, {
    itemId: item.id,
    itemLabel: item.label,
    path: item.path,
    source,
  });
};

export type { NavSource };
export { trackNavigationItem };
